import ListProcesses from "@/views/packing_house/process/harvested_batches/ListProcesses.vue";
import ShowProcess from "@/views/packing_house/process/harvested_batches/ShowProcess.vue";
import ListHarvestedBatches from "@/views/packing_house/process/harvested_batches/ListHarvestedBatches.vue";
import ShowHarvestedBatch from "@/views/packing_house/process/harvested_batches/ShowHarvestedBatch.vue";
import NewHarvestedBatch from "@/views/packing_house/process/harvested_batches/NewHarvestedBatch.vue";
import EditHarvestedBatch from "@/views/packing_house/process/harvested_batches/EditHarvestedBatch.vue";

const ENTITY = "ph";
const ROLE = "process";
const PERMISSION = "harvested_batches";
const ROUTE_NAME_PREFIX = `${ENTITY}_${ROLE}_${PERMISSION}`;
const META = {
  entity: ENTITY,
  role: ROLE,
  permission: PERMISSION
};

export default [
  {
    path: "/ph/:packing_house_id/process/harvested_batches/list_processes",
    name: `${ROUTE_NAME_PREFIX}_list_processes_path`,
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/process/harvested_batches/show_process/:packing_house_process_id",
    name: `${ROUTE_NAME_PREFIX}_show_process_path`,
    component: ShowProcess,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/process/harvested_batches/:packing_house_process_id/list",
    name: `${ROUTE_NAME_PREFIX}_list`,
    component: ListHarvestedBatches,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/process/harvested_batches/:packing_house_process_id/show/:harvested_batch_id",
    name: `${ROUTE_NAME_PREFIX}_show`,
    component: ShowHarvestedBatch,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/process/harvested_batches/:packing_house_process_id/new",
    name: `${ROUTE_NAME_PREFIX}_new`,
    component: NewHarvestedBatch,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/process/harvested_batches/:packing_house_process_id/edit/:harvested_batch_id",
    name: `${ROUTE_NAME_PREFIX}_edit`,
    component: EditHarvestedBatch,
    props: true,
    meta: META
  }
];
